/* Constants */
import { PAGE_TYPE_MEET_OUR_TECHS } from '@constants/pages';
/* Types */
import { Children } from 'types/base.types';
/* Components */
import { getLayout } from '@components/PageLayouts/Layout/Standard';
import MeetOurTechsPage from '@scenes/MeetOurTechsPage';
import Head from 'next/head';
import { generateNextSeo } from 'next-seo/pages';

function MeetOurTechs(): Children {
  return (
    <>
      <Head>{generateNextSeo({ title: 'Meet Our Techs' })}</Head>
      <MeetOurTechsPage />
    </>
  );
}

MeetOurTechs.pageAttributes = { page: PAGE_TYPE_MEET_OUR_TECHS };
MeetOurTechs.Layout = getLayout({ promo: true, footer: true });

export default MeetOurTechs;
